// Delegate clicks so quantity controls also work after WooCommerce replaces cart HTML.
document.addEventListener('click', function(event) {
    const button = event.target.closest('.quantity-selector .minus-btn, .quantity-selector .plus-btn');
    if (!button || button.disabled) {
        return;
    }

    const selector = button.closest('.quantity-selector');
    const input = selector.querySelector('input[type="number"]');
    if (!input || input.readOnly || input.matches(':disabled') || selector.closest('[hidden]')) {
        return;
    }

    event.preventDefault();
    const previousValue = input.value;
    const direction = button.classList.contains('plus-btn') ? 1 : -1;

    if (input.step === 'any') {
        // Native stepping is unavailable for step="any"; use one unit within the limits.
        const min = input.min === '' ? 0 : Number(input.min);
        const max = input.max === '' ? Infinity : Number(input.max);
        const value = input.value === '' ? min : Number(input.value);
        input.value = String(Math.min(max, Math.max(min, value + direction)));
    } else {
        // Read the current limits on every click: variation selection can change them.
        // Native stepping also handles decimal steps, empty values and step alignment.
        if (direction > 0) {
            input.stepUp();
        } else {
            input.stepDown();
        }
    }

    if (input.value !== previousValue) {
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
    }
});
